// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__zLVkL","errorPageTextContainer":"ErrorBoundary_errorPageTextContainer__7ERCO","logo":"ErrorBoundary_logo__-RMZI"};